<template>
	<div class>
		<drawer
			:title="addEditTitle"
			:dialogShow="addEditShow"
			@handleChange="handleChangeDrawer"
		>
			<div slot="body">
				<div class="pay-mains">
					<el-form
						ref="form"
						class="mobile-ruleForm card-ruleForm"
						label-width="114px"
						label-position="left"
					>
						<div v-if="!form.id">
              <el-form-item
                class="el-form-item-update"
                ref="payWay"
                label="支付方式"
                prop="payWay"
              >
                <el-select
                  v-model="form.payWay"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in optionName"
                    :key="item.payCode"
                    :label="item.payName"
                    :value="item.payCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="el-form-item-update"
                ref="dataMonth"
                label="选择月份"
                prop="dataMonth"
              >
                <el-date-picker
                  v-model="form.dataMonth"
                  type="month"
                  value-format="yyyy-MM"
                  placeholder="选择月份"
                  style="width: 200px;"
                  :clearable="false"
                  @change="getJieYu"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item
                class="el-form-item-update"
                ref="payWay"
                label="支付方式"
                prop="payWay"
              >
                {{form.payWayCn}}
              </el-form-item>
              <el-form-item
                class="el-form-item-update"
                ref="dataMonth"
                label="选择月份"
                prop="dataMonth"
              >
                {{dataMonth}}
              </el-form-item>
            </div>
            <el-form-item
							class="el-form-item-update"
							ref="amount"
							label="现金结余"
							prop="amount"
						>
							{{amounts.residueAmount}}
						</el-form-item>
						<el-form-item
							class="el-form-item-update"
							ref="amount"
							label="缴款金额"
							prop="amount"
						>
							<el-input
								v-model="form.amount"
								placeholder="请输入缴款金额"
								maxlength="8"
							></el-input>
						</el-form-item>
            <el-form-item
							class="el-form-item-update"
							ref="thirdOrderId"
							label="交易流水号"
							prop="thirdOrderId"
              v-show="form.payWay == 'bankcard'"
						>
							<el-input
								v-model="form.thirdOrderId"
								placeholder="请输入交易流水号"
								maxlength="30"
							></el-input>
						</el-form-item>
						<div class="refund_box">
							备注：
							<el-input
								type="textarea"
								maxlength="150"
								show-word-limit
								:rows="3"
								placeholder="请输入备注"
								v-model="form.remark"
								style="padding-top: 10px;"
							></el-input>
						</div>
					</el-form>
				</div>
				<div class="drawer-footer">
					<div class="back el-icon-back" @click="back"></div>
						<el-button
              v-if="!form.id"
							type="primary"
							class="small-btn"
							@click="onSubmit"
							>提交申请</el-button
						>
            <el-button
              v-else
							type="primary"
							class="small-btn"
							@click="onUpdate"
							>确定修改</el-button
						>
				</div>
			</div>
		</drawer>
    <pay ref="payForm" :parmar="parmar" @change="payChange"></pay>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import drawer from '../../../components/common/drawer'
import { decrypt, encrypt } from "../../../assets/javascript/untils";
import pay from "./pay"
export default {
	mixins: [minxin],
	components: { drawer, pay},
	data() {
		return {
			addEditTitle: '',
			addEditShow: false,
			optionName: [], // 支付方式
			form: {
				id: '',
        thirdOrderId: '',
        amount: '',
        remark: '',
        dataMonth: ''
			},
			parmar: {},
      amounts: {},
      dataMonth: ''
		}
	},
	created() {
		this.editInit()
	},
	methods: {
		back() {
			this.addEditShow = false
			this.$emit('change', false)
			this.$refs['form'].resetFields()
		},
		editInit() {
			this.$on('set', function(org) {
				Object.assign(this.$data, this.$options.data())
				this.userInfo = JSON.parse(localStorage.getItem('shopInfo'));
				if (org) {
          this.addEditTitle = '立即上缴修改';
          this.$api.get(this.$url.fundTransferSum.fundTransferOrderGet, {
            id: org
          }).then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
              this.dataMonth = this.formatMonth(this.form.dataMonth);
              this.form.dataMonth = this.formatMonth(this.form.dataMonth) + '-' + '01';
              this.amounts.residueAmount = res.fundAmount;
            }
          }).catch(error => {});
				} else {
          this.addEditTitle = '立即上缴';
					this.addEditShow = true;
        }
				this.getPayList();
			})
		},
    async getPayList () {
      let a = await this.$api.get(this.$url.order.getToken);
      let b = await this.$api.get(this.$url.fundTransferSum.fundTransferPayWayList);
      if (a) this.form.repeatToken = a;
      if (b) this.optionName = b;
    },
    getJieYu (val) {
      this.$api
        .post(this.$url.fundTransferSum.get, {
          beginTime: val + '-01',
          endTime: val + '-01'
        })
        .then(res => {
          this.amounts = res;
        })
        .catch(error => {
          this.error = true;
        });
    },
		handleChangeDrawer() {
			this.$refs['form'].clearValidate();
			this.addEditShow = false;
			this.$emit('change', true);
		},
		onSubmit(values) {
      console.log(this.form);
			if (!this.form.payWay) {
				return this.$message.error('请选择支付方式')
			} else if (!this.form.dataMonth) {
				return this.$message.error('请选择月份')
			} else if (this.form.amount == '0') {
				return this.$message.error('缴款金额不能为零')
			} else if (!this.form.amount ) {
				return this.$message.error('请输入缴款金额')
			} else if (!/^(([1-9]{1}\d*)|(0))(\.\d{1,2})?$/.test(this.form.amount)) {
				return this.$message.error('请输入正确的金额数字，最多两位小数')
			} else if (Number(this.form.amount) > Number(this.amounts.residueAmount)) {
        return this.$message.error('缴款金额不能大于现金结余金额')
      } else if (this.form.payWay == 'bankcard' && !this.form.thirdOrderId) {
        return this.$message.error('请输入交易流水号')
      }
      if (this.form.payWay == 'tonglianpos') {
        this.parmar = {
          amount: this.form.amount,
          payWay: this.form.payWay
        }
        this.$refs["payForm"].$emit("set", this.parmar)
      } else if (this.form.payWay == 'yinlianpos') {
        this.parmar = {
          amount: this.form.amount,
          payWay: this.form.payWay
        }
        this.$refs["payForm"].$emit("set", this.parmar)
      } else {
        const h = this.$createElement;
        this.$msgbox({
          title: '提示',
          message: h('p', null,[
            h('span', '本次缴费金额'),
            h('span', { style: 'color: red' }, this.form.amount),
            h('span',  '元，交易流水号为'),
            h('span', { style: 'color: red' }, this.form.thirdOrderId)
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(action => {
          this.payChange(true);
        });
      }
		},
    onUpdate () {
       if (this.form.amount == '0') {
				return this.$message.error('缴款金额不能为零')
			} else if (!this.form.amount) {
				return this.$message.error('请输入缴款金额')
			} else if (!/^(([1-9]{1}\d*)|(0))(\.\d{1,2})?$/.test(this.form.amount)) {
				return this.$message.error('请输入正确的金额数字，最多两位小数')
			} else if (Number(this.form.amount) > Number(this.amounts.residueAmount)) {
        return this.$message.error('缴款金额不能大于现金结余金额')
      } else if (this.form.payWay == 'bankcard' && !this.form.thirdOrderId) {
        return this.$message.error('请输入交易流水号')
      }
      this.$api.post(this.$url.fundTransferSum.update, this.form).then((res) => {
        if (res) {
          this.addEditShow = false;
          this.$message.success('操作成功');
          this.$emit('change', true);
        }
      })
      .catch((error) => {})
    },
    payChange (org) {
      if (org) {
        if (this.form.payWay == 'yinlianpos') {
          this.form.payType = org;
        }
        if (this.form.dataMonth.split("-").length == 2) {
          this.form.dataMonth = this.form.dataMonth + '-01';
        }
        this.form.millisecond = new Date().getTime();
			  this.$api
				.post(this.$url.fundTransferSum.createFundOrder, encrypt(JSON.stringify(this.form)))
				.then((res) => {
					if (res) {
						this.addEditShow = false;
						this.$message.success('操作成功');
						this.$emit('change', true);
					} else {
            this.$api.get(this.$url.order.getToken).then(res => {
                if (res) {
                    this.form.repeatToken = res;
                }
            })
          }
				})
				.catch((error) => {})
      }
    },
		cancel(value) {
			let msg
			if (value == 'refuse') {
				msg = `确定要拒绝吗?`
			} else if (value == 'pass') {
				msg = `确定要同意吗?`
			} else {
				msg = `确定要撤销吗?`
			}
			const h = this.$createElement
			this.$msgbox({
				title: '提示',
				message: h('p', null, [
					h('span', { style: 'color: red' }, msg),
				]),
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				center: true,
			}).then((action) => {
				if (value == 'pass' || value == 'refuse') {
					this.$api
						.post(this.$url.companyLeave.audit, {
							id: this.form.id,
							auditStatus: value,
						})
						.then((res) => {
							if (res) {
								this.addEditShow = false
								this.$message.success('操作成功')
								this.$emit('change', true)
							}
						})
						.catch((error) => {})
				} else {
					this.$api
						.get(this.$url.companyLeave.cancel, {
							id: this.form.id,
						})
						.then((res) => {
							if (res) {
								this.addEditShow = false
								this.$message.success('撤销成功')
								this.$emit('change', true)
							}
						})
						.catch((error) => {})
				}
			})
		},
	},
}
</script>
<style scoped lang="less">
@import '../../../assets/css/edit.less';
.toggle-text {
	padding: 0 20px;
}
.refund_box {
	background: #fff;
	padding: 10px 20px;

	.infos {
		color: #ff892a;
		padding-bottom: 10px;
	}
}
.leaveBox {
	background: #fff;
	padding: 10px 20px;
}
.member_bg {
	width: 100%;
	height: 56px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
/deep/ .el-dialog {
	margin-top: 20vh !important;
}
.pay-mains {
	padding: 0;
	background: @borderColor;

	.card-ruleForm {
		padding-bottom: 0;
		padding-top: 10px;
		/deep/ .el-form-item {
			border-bottom: 1px solid @borderColor;
			padding: 10px 20px;
			margin-bottom: 0;
		}
		.item-cards {
			background: #fff;
			padding: 20px;
			/deep/ .el-form-item__content {
				flex: 2;
				// text-align: right;
				// display: flex;
				margin-left: 0 !important;
				.el-form-item__error {
					right: 0;
				}
			}
		}
		.el-form-item-update {
			align-items: center;
			display: flex;
			margin: 0;
			// justify-content: space-between;
			border-bottom: 1px solid @borderColor;
			background: #fff;
			&:first-child {
				margin-top: 0;
			}
			/deep/ .el-form-item__label {
				font-size: 16px;
				font-weight: 500;
				// text-align: left;
			}
			/deep/ .el-form-item__content {
				flex: 2;
				text-align: right;
				// display: flex;

				margin-left: 0 !important;
				.el-form-item__error {
					z-index: 1;
					right: 0;
				}
			}

			/deep/ .el-input__inner {
				width: 200px;
				text-align: left;
				// text-align: right;
			}

			/deep/ .el-radio__inner {
				width: 22px;
				height: 22px;
			}
			/deep/ .el-radio__label {
				font-size: 16px;
			}

			/deep/ .el-input.is-disabled .el-input__inner {
				background: #fff;
			}
			/deep/ .el-link {
				width: 160px;
			}
		}
		.head-img {
			//   height: 90px;
			padding: 10px;
			background: #fff;
			display: flex;
			align-items: center;
			border-bottom: 1px solid #dceaed;
			/deep/ .el-form-item__content {
				.top-img {
					width: 100%;
					border-radius: 50%;
					.text-upload {
						position: absolute;
						top: 20px;
						right: 0;
						line-height: initial;
					}
				}
				.el-link {
					width: auto;
					cursor: pointer;
				}
				.img {
					width: 60px;
					height: 60px;
				}
			}
		}
	}
}
.moneys {
	color: red !important;
}
</style>
